import { useAdminDeliveryProposalDetailPageProps } from "./fetch";
import { AdminDeliveryProposalDetailPageUi } from "./ui";

export const AdminDeliveryProposalDetailPage: React.FC<{
  offerCargoIdStr: string | undefined;
}> = (params) => {
  const props = useAdminDeliveryProposalDetailPageProps(params.offerCargoIdStr);
  return <AdminDeliveryProposalDetailPageUi {...props} />;
};
